export default __webpack_public_path__ + "static/media/Bedroom4.c2e0898f.png";